import React from 'react'
import HeaderTwo from '../../components/header/HeaderTwo'
import RegisterRE from './RegisterRE'
import Footer from '../../components/footer/Footer'

function RegisterREDetails() {
  return (
    <>
    <HeaderTwo/>
    <main>
        <RegisterRE/>
    </main>
    <Footer/>
    </>
  )
}

export default RegisterREDetails